import { GetStaticProps } from "next/types"
import nextI18nextConfig from "next-i18next.config"
import { serverSideTranslations } from "next-i18next/serverSideTranslations"
import { Page } from "types/page"
import DefaultErrorPage from "next/error"
import { SSRConfig } from "next-i18next"
import { CourseContent, Quiz } from "interfaces/courses"
import { fetchCourseWithSlug, fetchQuiz } from "@cs/lib/firebase/courses-v6/getCourses"
import QuizPage from "@cs/screens/courses-beta/course/QuizPage"

interface ChapterPageProps extends SSRConfig {
  quiz?: Quiz
  course: CourseContent
  nextSectionSlug: string
}

const EnrollPage: Page<ChapterPageProps> = ({ quiz, course, nextSectionSlug }) => {
  if (!course || !quiz || !nextSectionSlug) {
    return (
      <>
        <DefaultErrorPage statusCode={404} />
      </>
    )
  }

  const props = {
    quiz,
    course,
    nextSectionSlug,
  }

  return <QuizPage {...props} />
}

export default EnrollPage

export const getStaticPaths = () => ({
  paths: [],
  fallback: "blocking",
})

export const getStaticProps: GetStaticProps = async ({ locale, params }) => {
  const { courseSlug } = params ?? {}
  const course = courseSlug?.toString() || ""
  const quiz = "advanced"
  locale = locale ?? "en"
  const courseContent = await fetchCourseWithSlug(course, locale)

  const quizId = `${quiz}-${courseContent?.id}`

  // get quiz content
  const quizContent = await fetchQuiz(quizId, locale)

  return {
    props: {
      quiz: quizContent,
      course: courseContent,
      nextSectionSlug: `/new-courses/${courseContent?.slug}/certificate`,
      ...(await serverSideTranslations(
        locale ?? "en",
        ["common", "footer", "nav", "courses", "landing-page"],
        nextI18nextConfig,
      )),
    },
  }
}
